import { FSMPlan } from 'containers/integrations/fsm-integration/constants';
import routesPath from 'routes/RoutesPath';

export enum FSM_PLANS {
  FIELD_SERVE = 'field_serve',
  FIELD_SERVE_PLUS = 'field_serve_plus'
}

export const FSM_SHOW_MODAL_PLAN_STATES = [FSMPlan.FREE, FSMPlan.NO_PLAN];

export const FSM_FREE_PLAN_ROUTES = [
  routesPath.JOBS,
  routesPath.COMMISSION_SETTINGS,
  routesPath.EXTERNAL_COMPANY_SETTINGS,
  routesPath.MAP_VIEWS_SETTINGS,
  routesPath.TAGS,
  routesPath.ADJUSTMENT_SETTINGS
];

export const FSM_UPGRADE_NEEDED_ROUTES = [
  routesPath.ACCOUNTING_PAY_RUNS,
  routesPath.MAPS,
  routesPath.ACCOUNTING_EXTERNAL_COMPANY,
  routesPath.REPORTS,
  routesPath.SERVICE_AREAS_SETTINGS,
  routesPath.PAY_SCHEDULE_SETTINGS
];

export const FSM_ENDED_MODAL_ROUTES = [
  routesPath.MAPS,
  routesPath.ACCOUNTING_EXTERNAL_COMPANY,
  routesPath.REPORTS,
  routesPath.SERVICE_AREAS_SETTINGS,
  routesPath.PAY_SCHEDULE_SETTINGS
];

export const FSM_BANNER_ROUTES = [
  ...FSM_UPGRADE_NEEDED_ROUTES,
  routesPath.EXPENSE_REPORT,
  routesPath.PAYMENT_REPORT,
  routesPath.COMMISSION_REPORT,
  routesPath.AREA_PERFORMANCE_REPORT,
  routesPath.EXTERNAL_COMPANY_REPORT,
  routesPath.ACCOUNTING_PAY_RUNS_LIST
];
